import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import AccountHome from "../views/AccountHome";
import MyAgentReports from "../views/MyAgentReports";
import MyCreatedAgentRequests from "../views/MyCreatedAgentRequests";
import MyParticipatedAgentRequests from "../views/MyParticipatedAgentRequests";
import MyProcessedAgentRequests from "../views/MyProcessedAgentRequests";

export default function Account(props) {

  const appContext = useContext(AppContext);

  const [ view, setView ] = useState(null);

  async function init() {
    //run initializations here
  }

  function getView() {
    if(
      !appContext.navSubItem &&
      !appContext.navExtraItem &&
      !appContext.navMoreItem
    ) {
      return <AccountHome/>
    } else if(
      appContext.navSubItem === 'my-agent-reports' &&
      !appContext.navExtraItem &&
      !appContext.navMoreItem
    ) {
      return <MyAgentReports/>
    } else if(
      appContext.navSubItem === 'my-created-agent-requests' &&
      !appContext.navExtraItem &&
      !appContext.navMoreItem
    ) {
      return <MyCreatedAgentRequests/>
    } else if(
      appContext.navSubItem === 'my-processed-agent-requests' &&
      !appContext.navExtraItem &&
      !appContext.navMoreItem
    ) {
      return <MyProcessedAgentRequests/>
    } else if(
      appContext.navSubItem === 'my-participated-agent-requests' &&
      !appContext.navExtraItem &&
      !appContext.navMoreItem
    ) {
      return <MyParticipatedAgentRequests/>
    } 

    return null;
  }

  useEffect(() => {
    init();
  }, [ ])

  useEffect(() => {
    const _view = getView();
    if(_view) {
      setView(_view);
    }
  }, [ appContext.navSubItem, appContext.navExtraItem, appContext.navMoreItem ])

  //return desired view
  return view;
}